import type { CRMUser } from '../types';

/** Active internal team members eligible for trip owner / traveler pickers. */
export function filterPeopleTravelTeamMembers(users: CRMUser[]): CRMUser[] {
  return users
    .filter(
      u =>
        u.isActive &&
        !u.supplierOrgId &&
        (u.role === 'employee' || u.role === 'admin' || u.role === 'staff'),
    )
    .sort((a, b) =>
      peopleTravelMemberLabel(a).localeCompare(peopleTravelMemberLabel(b)),
    );
}

export function peopleTravelMemberLabel(u: CRMUser): string {
  return u.displayName || u.email || u.uid;
}
